








































import { Component, Mixins, Watch } from "vue-property-decorator";
import { DomainRegistry } from "../../../../domain";
import { ObjectUtility } from "../../../../utilities";
import { IConfiguration } from "../../../../domain/configuration";

@Component({
  components: {
  }
})
export default class SystemSettingTerminalEditor extends Mixins() {
  data(): any {
    return {
      hostName: null as string,
      saveHostName: null as string,
      systemConfiguration: null as string,
      terminalConfiguration: null as string,
      mergedConfiguration: null as string,
    };
  }
  hostName: string;
  saveHostName: string;
  systemConfiguration: string;
  terminalConfiguration: string;
  mergedConfiguration: string;

  mounted() {
    this.hostName = this.$store.getters.hostName;
    this.load();
  }

  async load(): Promise<void> {
    this.saveHostName = this.hostName;
    await this.refreshSystemConfiguration();
    await this.refreshTerminalConfiguration();
    await this.updateMergedConfiguration();
  }

  async refreshSystemConfiguration(): Promise<void> {
    const repository = DomainRegistry.developer.getConfigurationRepository();
    const defaultConfiguration = repository.getDefaultConfiguration();
    const systemConfiguration = await repository.getSystemConfiguration();
    const mergedSystemConfiguration = ObjectUtility.mergeDeeply(defaultConfiguration, systemConfiguration);
    this.systemConfiguration = JSON.stringify(mergedSystemConfiguration, null , "  ");
  }

  async refreshTerminalConfiguration(): Promise<void> {
    this.terminalConfiguration = null;
    if (!this.hostName || this.hostName === "") { return; }
    const repository = DomainRegistry.developer.getConfigurationRepository();
    const terminalConfiguration = await repository.getTerminalConfiguration(this.hostName);
    this.terminalConfiguration = JSON.stringify(terminalConfiguration, null , "  ");
  }

  @Watch("terminalConfiguration")
  updateMergedConfiguration(): void {
    try {
      const mergedConfiguration = ObjectUtility.mergeDeeply(JSON.parse(this.systemConfiguration), JSON.parse(this.terminalConfiguration));
      this.mergedConfiguration = JSON.stringify(mergedConfiguration, null , "  ");
    } catch (e) {
      console.error(e);
      this.mergedConfiguration = e.toString();
    }
  }

  async save(): Promise<void> {
    const configuration = this.getEditingConfiguration();
    if (!configuration) { return; }

    const index = await this.$commonDialogs.confirmation.confirmSaveCancel(
      null,
      ["端末設定を保存してもよろしいですか？"]
    );
    if (index !== 0) { return; }
    const repository = DomainRegistry.developer.getConfigurationRepository();
    repository.registerTerminalConfiguration(this.saveHostName, configuration)
    .then(() => {
      this.$success("設定保存", "端末設定の保存に成功しました。");
      this.load();
    })
    .catch(e => {
      this.$error("設定保存", "端末設定の保存に失敗しました。", e);
    });
  }

  getEditingConfiguration(): IConfiguration {
    try {
      if (!this.terminalConfiguration) {
        this.$warn("端末設定", "端末設定が空です。");
        return null;
      }
      if (!this.saveHostName || this.saveHostName === "") {
        this.$warn("端末設定", "端末名が空です。");
        return null;
      }
      return JSON.parse(this.terminalConfiguration) as IConfiguration;
    } catch (e) {
      this.$error("端末設定", "値の変換に失敗しました。", e);
    }
    return null;
  }
}
